module.exports = __webpack_public_path__ + "img/tpc-27.ea9380f5.webp";